export default "__VITE_ASSET__DFbCQeHr__"